
    import I18n from 'i18nObj';
    
      import 'translations/assignments.assignment_group_list_item';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('assignments.assignment_group_list_item');
  